module.exports = __webpack_public_path__ + "static/media/19ю101.ea4d7fcc.webp";